import { Employer } from '../models/employer';
import { AdditionalIncome } from '../models/additionalincome';

export class IncomeInfo {
    constructor (
        public additionalIncome: AdditionalIncome = new AdditionalIncome(),
        public employments: Employer[] = [],
        public verifastEnabled: boolean = false
    ) { }
}
